module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.05.a-6fcd858b2a2fb4f9b6c293d4411616e3.svg";